<template>
	<div>
		<el-dialog
			:title="title"
			:visible.sync="dialogVisibles"
			append-to-body
			style="overflow: auto;height: 100%;"
			width="790px"
			:destroy-on-close="true"
			:close-on-click-modal="false"
			@close="closeDialog()">
			<c-r-m-customer-log :crmType="crmType" :id="id"/>
		</el-dialog>
	</div>
</template>

<script>
	import CRMCustomerLog from '@/components/table/new/customer/CRMCustomerLog'
	export default {
		components: {
			CRMCustomerLog
		},
		data() {
			return {
				dialogVisibles:false
			}
		},
		props: {
			// id
			id: {
				type: [String,Number],
				default: ''
			},
			// CRM类型
			crmType: {
				type: String,
				default: ''
			},
			// 控制dialog显示
			dialogVisible:{
				type: Boolean,
				default: false
			},
			// dialog标题
			title: {
				type: String,
				default: ''
			}
		},
		watch: {
			dialogVisible: function(value) {
				this.dialogVisibles = value
			}
			
		},
		methods: {
			// 关闭dialog弹窗
			closeDialog(){
				this.$emit('close',false)
				this.dialogVisibles = false
			},
		},
	}
</script>

<style scoped>
	/deep/ .el-dialog{
		overflow: auto;
	}
	/deep/ .el-dialog__body {
	    overflow: auto;
	}
</style>